import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const StyledTabs = styled.ul`
  display: flex;
  justify-content: ${props => props.alignTabs};
  list-style-type: none;
  padding: 0;
  margin: 10px 0 0;
`;

class Tabs extends React.Component {
  static propTypes = {
    children: PropTypes.node.isRequired,
    defaultActiveTabIndex: PropTypes.number,
    textColor: PropTypes.string,
    alignTabs: PropTypes.oneOf(['flex-start', 'center', 'space-between', 'space-around', 'flex-end']),
    activeTabIcon: PropTypes.node,
  }

  static defaultProps = {
    defaultActiveTabIndex: 0,
    textColor: '#eee',
    alignTabs: 'flex-start',
    activeTabIcon: null,
  }

  constructor(props) {
    super(props);
    this.state = {
      activeTabIndex: this.props.defaultActiveTabIndex,
    };
    this.handleTabClick = this.handleTabClick.bind(this);
  }

  // Toggle currently active tab
  handleTabClick(tabIndex) {
    this.setState(prevState => ({
      activeTabIndex: tabIndex === prevState.activeTabIndex ? (
        this.props.defaultActiveTabIndex
      ) : (tabIndex),
    }));
  }

  // Encapsulate <Tabs/> component API as props for <Tab/> children
  renderChildrenWithTabsApiAsProps() {
    return React.Children.map(this.props.children, (child, index) => React.cloneElement(child, {
      onClick: this.handleTabClick,
      tabIndex: index,
      isActive: index === this.state.activeTabIndex,
      textColor: this.props.textColor,
      activeTabIcon: this.props.activeTabIcon,
    }));
  }

  // Render current active tab content
  renderActiveTabContent() {
    const { children } = this.props;
    const { activeTabIndex } = this.state;
    return children[activeTabIndex].props.children;
  }

  render() {
    return (
      <div style={{ marginTop: 20 }}>
        <StyledTabs alignTabs={this.props.alignTabs}>
          {this.renderChildrenWithTabsApiAsProps()}
        </StyledTabs>
        {this.renderActiveTabContent()}
      </div>
    );
  }
}

export default Tabs;
